import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';

import { WorkArea } from '@xsolla/ui-core';

import { PageError, Preloader } from '../../components/ui';
import { useProjects } from '../../contexts/settings';
import { tokenExpiryErrorCheck } from '../../utils';
import LoginProjects from './LoginProjects';
import LoginStartPage from './LoginStartPage';

const ProjectsWorkArea = styled.div`
  min-width: 750px;
`;

const Dashboard = ({ history }: RouteComponentProps): JSX.Element => {
  const { projects, projectsFetching, error, babkaLoginClient, showBabkaLogin } = useProjects();
  const intl = useIntl();

  const reloadPage = useCallback(() => {
    history.go(0);
  }, []);

  const loginPage = useCallback(() => {
    history.push('/');
  }, []);

  if (projectsFetching || (!projects && !error)) {
    return <Preloader />;
  }

  if (error) {
    const expiredToken = tokenExpiryErrorCheck(error.code);
    return (
      <PageError
        title={intl.formatMessage({ id: 'app.error.page.label' })}
        error={error}
        buttonText={intl.formatMessage({
          id: `${expiredToken ? 'button.login' : 'button.reload'}`
        })}
        pageName="dashboard"
        onClick={expiredToken ? loginPage : reloadPage}
      />
    );
  }

  const showProjects = projects && projects.length > 0;

  if (showProjects) {
    return (
      <ProjectsWorkArea>
        <WorkArea>
          <LoginProjects
            loginProjects={projects}
            babkaLoginClient={babkaLoginClient}
            showBabkaLogin={showBabkaLogin}
          />
        </WorkArea>
      </ProjectsWorkArea>
    );
  }

  return <LoginStartPage />;
};

export default withRouter(Dashboard);
